// extracted by mini-css-extract-plugin
module.exports = {"operator":"operator_operator__3MAzb","operatorBelowCards":"operator_operatorBelowCards__18z_w"};